<template>
  <b-tabs>
    <b-tab>
      <template slot="title">
        <i class="icon-list"></i>
      </template>
      <b-list-group class="list-group-accent">
        <b-list-group-item
          class="list-group-item-accent-secondary bg-light d-flex justify-content-between align-items-center"
        >
          <span class="font-weight-bold text-muted text-uppercase small">
            Notifications
          </span>
        </b-list-group-item>
        <b-list-group-item
          active-class="activus"
          v-for="(notification, index) in notifyList"
          :key="notification.id"
          :to="GetNotificationLink(notification)"
          :index="index"
          :class="
            'list-group-item-accent-' +
              notification.color +
              ' list-group-item-divider'
          "
        >
          <div>
            <span v-if="GetNotificationLink(notification)" class="fa fa-link mr-1"></span>
            <span v-html="notification.name"></span>
          </div>
          <small class="text-muted mr-3">
            <i class="icon-calendar"></i>&nbsp;&nbsp;
            {{ fromNowDate(notification.createDateTimeUtc) }}
          </small>
          <div
            class="content-short small pt-1"
            v-if="notification.shortDescription"
          >
            <p v-html="notification.shortDescription"></p>
          </div>
        </b-list-group-item>
      </b-list-group>
      <div class="text-center mt-2 mb-3">
        <b-button variant="primary" size="sm" @click="loadNotifications()">
          Load More
        </b-button>
      </div>
    </b-tab>
  </b-tabs>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
export default {
  mixins: [myCommonDataMixin],
  name: 'DefaultAside',
  computed: {
    notifyList: {
      get() {
        let arr = [];
        arr = this.notificationsList.sort((a, b) =>
          new Date(a.createDateTimeUtc) < new Date(b.createDateTimeUtc)
            ? 1
            : new Date(a.createDateTimeUtc) === new Date(b.createDateTimeUtc)
            ? new Date(a.createDateTimeUtc) > new Date(b.createDateTimeUtc)
              ? 1
              : -1
            : -1
        );
        return arr
          .slice()
          .reverse()
          .reverse();
      },
      set(val) {}
    }
  },
  data() {
    return {
      loadingNotify: false,
      notifyPage: 0,
      notificationsList: []
    };
  },

  methods: {
    hookToNotificationsChannel() {
      this.$userHub.$off('new-notification-added', this.notifyAddedEvent);
      this.$userHub.$on('new-notification-added', this.notifyAddedEvent);
    },
    fromNowDate(date) {
      return this.$moment
        .utc(date)
        .local()
        .fromNow();
    },
    GetNotificationLink(notification) {
      if(notification.linkToUrl) {
        return notification.linkToUrl;
      } else if(notification.linkToRouter) {
        if(notification.linkToRouter.paramArgs)
          notification.linkToRouter.params = notification.linkToRouter.paramArgs;
        return notification.linkToRouter;
      } else {
        return '';
      }
    },
    toastNotify(notification) {
      const h = this.$createElement;
      setTimeout(() => {
        this.$bvToast.toast(
          notification.shortDescription
            ? h('div', {
                domProps: { innerHTML: notification.shortDescription }
              })
            : '',
          {
            to: this.GetNotificationLink(notification),
            title: notification.name,
            variant:
              notification.color == 'secondary'
                ? 'default'
                : notification.color,
            autoHideDelay: 7000
          }
        );
        this.updateReadSpecific(notification.id);
      }, 200);
    },
    notifyAddedEvent(args) {
      let notific = args.notification;
      if( notific.id == null) {
        if(notific.name.includes('Message from')) {
          let currentRoute = this.$route.name;
          if(!currentRoute.includes('Communications.')) {
            this.toastNotify(notific);
          }
        } else {
          this.toastNotify(notific);
        }
      } else if (this.notificationsList.find(a => a.id == notific.id) == null) {
        this.toastNotify(notific);
        this.notificationsList.push(notific);
      }
    },
    updateReadSpecific(id) {
      this.$http
        .post('/api/common/notifications/update-read/' + id, {})
        .then(resp => {})
        .catch(err => {});
    },
    loadNotifications() {
      this.notifyPage++;
      this.loadingNotify = true;
      this.$http
        .post('/api/common/notifications/list', {
            page: this.notifyPage,
            perPage: 10
        })
        .then(resp => {
          let itms = resp.data.items;
          let arrs = [];
          itms.forEach(notific => {
            if (this.notificationsList.find(a => a.id == notific.id) == null) {
              arrs.push(notific);
            }
          });
          this.notificationsList = this.notificationsList.concat(arrs);
          this.loadingNotify = false;
        })
        .catch(err => {
          this.loadingNotify = false;
        });
    }
  },
  beforeDestroy: function() {
    //clean SignalR event
    this.$userHub.$off('new-notification-added', this.notifyAddedEvent);
  },
  watch: {
    getNotifyBusStatus: {
      handler: function(val, oldVal) {
        if(val)
          this.hookToNotificationsChannel();
      },
      deep: true
    },
  },
  mounted() {
    this.hookToNotificationsChannel();
    this.loadNotifications();
  }
};
</script>
